var exports = {
  "k": "GuildIcon.module__container___OWVQOX",
  "q": "GuildIcon.module__containerNoIcon___OWVQOX",
};

module.exports = exports;
